import { Button, Modal } from 'components/core';
import { FC } from 'react';
import { IoCheckmarkCircle, IoCheckmarkCircleOutline } from 'react-icons/io5';
import { Styled, IteroOrderSuccessModalProps } from '.';
import { useI18n } from '../../contexts/i18n';

export const IteroOrderSuccessModal: FC<IteroOrderSuccessModalProps> = ({
  onClose,
}) => {
  const i18n = useI18n();
  return (
    <Modal>
      <Styled.ErrorContainer>
        <IoCheckmarkCircleOutline size="72px" style={{ color: 'green' }} />
        <Styled.LoadingMessage>
          {i18n['Your iTero scanner Order has been placed successfully!']}
        </Styled.LoadingMessage>
        <Button size="sm" onClick={onClose}>
          {i18n['Done']}
        </Button>
      </Styled.ErrorContainer>
    </Modal>
  );
};
